import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import SvgVue from "svg-vue3";
import Toast, { POSITION, TYPE } from "vue-toastification";
import * as Sentry from "@sentry/vue";
import "@vuepic/vue-datepicker/dist/main.css";
import "vue3-carousel/dist/carousel.css";

const toastOptions = {
  toastDefaults: {
    [TYPE.ERROR]: {
      timeout: 5000,
    },
    [TYPE.SUCCESS]: {
      timeout: 3000,
    },
  },
  toastClassName: "toast--custom",
  transition: "Vue-Toastification__bounce",
  position: POSITION.BOTTOM_RIGHT,
  closeOnClick: true,
  maxToasts: 10,
  timeout: 3000,
  pauseOnHover: true,
  newestOnTop: true,
  icon: true,
  closeButton: false,
  pauseOnFocusLoss: false,
  hideProgressBar: false,
  draggable: false,
};

createInertiaApp({
  resolve: (name) => import(`./Pages/${name}.vue`),
  setup({ el, app, props, plugin }) {
    const VueApp = createApp({ render: () => h(app, props) })
      .use(plugin)
      .use(SvgVue)
      .use(Toast, toastOptions)
      .mixin({ methods: { route } });

    if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging") {
      Sentry.init({
          VueApp,
          dsn: "https://d01570d186aa4f309ee64de3112af4a5@o315551.ingest.sentry.io/4504117124202496",
          environment: `${process.env.NODE_ENV}-frontend`,
      });
    }
    return VueApp.mount(el);
  },
});

InertiaProgress.init({ color: "#792fdb" });
